import { render, staticRenderFns } from "./BenefitTriggerProductsTable.vue?vue&type=template&id=1fdc99bc&scoped=true"
import script from "./BenefitTriggerProductsTable.vue?vue&type=script&lang=js"
export * from "./BenefitTriggerProductsTable.vue?vue&type=script&lang=js"
import style0 from "./BenefitTriggerProductsTable.vue?vue&type=style&index=0&id=1fdc99bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc99bc",
  null
  
)

export default component.exports